import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  constructor(private http: HttpClient) { }

  checkForScheduledMaintenanceLockout(): Observable<boolean> {
    let reqOptions = {
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin' : "*",
      },
    };

    return this.http.get<{ canLogin: boolean, scheduledTime: string | null }>(`${environment.dataServicesURL}maintenance`, reqOptions).pipe(
      map(res => {
        return res.canLogin;
      })
    );
  }

  checkForScheduledMaintenanceChanges(): Promise<string | null | undefined> {
    let reqOptions = {
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin' : "*",
      },
    };

    return this.http.get<{ scheduledTime: string | null }>(`${environment.dataServicesURL}maintenance`, reqOptions)
      .pipe(
        map(res => res.scheduledTime)
      ).toPromise();
  }
}